import { render, staticRenderFns } from "./extraReward.vue?vue&type=template&id=401ed286"
import script from "./extraReward.vue?vue&type=script&lang=js"
export * from "./extraReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401ed286')) {
      api.createRecord('401ed286', component.options)
    } else {
      api.reload('401ed286', component.options)
    }
    module.hot.accept("./extraReward.vue?vue&type=template&id=401ed286", function () {
      api.rerender('401ed286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponExpand/extraReward.vue"
export default component.exports